import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyDhmRsuA4XNCpYTjgVLkEH3FwNtdjDg9WQ',
  authDomain: 'bestway-eg.firebaseapp.com',
  projectId: 'bestway-eg',
  storageBucket: 'bestway-eg.appspot.com',
  messagingSenderId: '839684864331',
  appId: '1:839684864331:web:abc8d2c33ff5a49b2750ce',
};

//inital firebase

firebase.initializeApp(firebaseConfig);

//initialize services

const projectFirebase = firebase.firestore();
const projectStorage = firebase.storage();

export { projectFirebase, projectStorage };
